import React, { Component } from 'react'
import numeral from 'numeral'
import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'
import {
  queryRef,
  artistRef,
  scoresRef,
  topCitiesRef,
  topCountriesRef,
  reportRef,
  albumRef
} from '../../config'


export default class Research extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      query: '',
      queryResult: {}
    }
    this.handleSearchInput = this.handleSearchInput.bind(this)
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
  }


  handleSearchInput(e) {
    if (e.target.value.length === 0) {
      this.setState({
        queryResult: {}
      })
    }
    e.preventDefault();
    this.setState({
      query: e.target.value
    })
  }

  handleSearchSubmit(e) {
    e.preventDefault();
    this.setState({
      loading: true,
      queryResult: {}
    })

    if(this.state.query === ""){
      Alert.error('Please type value in search', {
          position: 'top-right',
          effect: 'scale',
          offset: '0',
		  timeout:'500000'
      });
      this.setState({
        loading: false,
        queryResult: {}
      })
      return
    }

    queryRef.push(this.state.query)
      .then(() => {
        let url = this.state.query.split(' ').join('-')
        let artstRef = artistRef.child(url)
        let albmRef = albumRef.child(url)
        let scresRef = scoresRef.child(url)
        let tpCitiesRef = topCitiesRef.child(url)
        let tpCountriesRef = topCountriesRef.child(url)
        albmRef
          .once('value', s => {
            let changes = {}
            if (s.exists()) {
              Object.keys(s.val()).map(k => { changes[k] = s.val()[k] })
              this.setState({
                loading: false,
                queryResult: Object.assign({}, this.state.queryResult, changes)
              })
            }
          })

        albmRef
          .on('child_changed', s => {
            console.log('albmREf changed', s.val())
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, { [s.key]: s.val() })
            })
          })
        albmRef
          .on('child_added', s => {
            console.log('album ref added', s.val())
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, s.val())
            })
          })

        scresRef.once('value', s => {
          let changes = {}
          if (s.exists()) {
            Object.keys(s.val()).map(k => { changes[k] = s.val()[k] })
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, changes)
            })
          }
        })
        scresRef.on('child_changed', s => {
          this.setState({
            loading: false,
            queryResult: Object.assign({}, this.state.queryResult, s.val())
          })
        })

        scresRef.on('child_added', s => {
          this.setState({
            loading: false,
            queryResult: Object.assign({}, this.state.queryResult, s.val())
          })
        })

        tpCitiesRef.once('value', s => {
          if (s.exists()) {
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, { topCities: s.val() })
            })
          }
        })

        tpCitiesRef.on('child_changed', s => {
          this.setState({
            loading: false,
            queryResult: Object.assign({}, this.state.queryResult, s.val())
          })
        })

        tpCitiesRef.on('child_added', s => {
          this.setState({
            loading: false,
            queryResult: Object.assign({}, this.state.queryResult, s.val())
          })
        })

        tpCountriesRef.once('value', s => {
          if (s.exists()) {
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, { topCountries: s.val() })
            })
          }
        })

        tpCountriesRef.on('child_changed', s => {
          this.setState({
            loading: false,
            queryResult: Object.assign({}, this.state.queryResult, s.val())
          })
        })
        tpCountriesRef.on('child_added', s => {
          this.setState({
            loading: false,
            queryResult: Object.assign({}, this.state.queryResult, s.val())
          })
        })

        artstRef
          .once('value', s => {
            console.log('yooo')
            let changes = {}
            if (s.exists()) {
              Object.keys(s.val()).map(k => { changes[k] = s.val()[k] })
              this.setState({
                loading: false,
                queryResult: Object.assign({}, this.state.queryResult, changes)
              })
            }
          })
        artstRef
          .on('child_changed', s => {
            console.log('something changed')
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, s.val())
            })
          })
        artstRef
          .on('child_added', s => {
            console.log('something changed', s.val())
            this.setState({
              loading: false,
              queryResult: Object.assign({}, this.state.queryResult, { [s.key]: s.val() })
            })
          })

        reportRef
          .child('2017')
          .orderByChild('Event Name')
          .equalTo(this.state.query)
          .once('value', s => {
            if (s.exists()) {
              this.setState({
                loading: false,
                queryResult: Object.assign({}, this.state.queryResult, { reportData: s.val() })
              })
            }
            else {
              console.log('cant find data for event')
            }
          })
      })



  }

  componentWillUnmount() {
    artistRef.off()
    topCountriesRef.off()
    topCitiesRef.off()
    queryRef.off()
    scoresRef.off()
    artistRef.off()
    albumRef.off()
  }



  render() {
    let avgProfit = 0
    let totalTicketsBought = 0
    let totalProfit = 0
    if (this.state.queryResult) {
      if (this.state.queryResult.reportData) {
        totalTicketsBought = Object.keys(this.state.queryResult.reportData).length
        Object.keys(this.state.queryResult.reportData).forEach(ticketKey => {
          totalProfit += +this.state.queryResult.reportData[ticketKey].Profit
        })
        console.log(`total profit ${totalProfit}`)
        console.log(`average profit per ticket ${totalProfit / totalTicketsBought}`)
        avgProfit = totalProfit / totalTicketsBought
      }
    }
    let resultRow = {
      marginTop: '30px'
    }
    // if (this.state.loading) {
    //   return (
    //     <div className="loader-wrap">
    //       <div className="loader">Loading...</div>
    //     </div>
    //   )
    // }
    return (
      <div>
      <div className='animated fadeIn'>
        <div className="search-area">
          <form onSubmit={this.handleSearchSubmit}>
            <div className="input-group">
              <input className='form-control' onChange={this.handleSearchInput} value={this.state.query} placeholder='search for an artist' />
              <button type="submit" className="input-group-addon">SEARCH</button>
            </div>
          </form>
        </div>
        <div className="album-area text-center">
          <div className="row flex-row">
            <div className="col-lg-2 col-md-4 col-12 col-sm-6">
              <div className="well well-sm filter-view">
                <span className="filter-icon"><i className="icon ion-ios-musical-notes"></i></span>
                <h4 className="album-heading">Latest Album</h4>
                <img className='album-img' height='110' src={this.state.queryResult ? this.state.queryResult.albumImage : ''} />
                <p className="sub-head">{this.state.queryResult ? this.state.queryResult.name : ''}</p>
                <small>{this.state.queryResult ? this.state.queryResult.releaseDate : ''}</small>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 col-sm-6">
              <div className="well well-sm filter-view">
                <span className="filter-icon"><i className="icon ion-ios-home"></i></span>
                <h4 className="album-heading">HomeTown</h4>
                <p className="sub-head">{this.state.queryResult ? this.state.queryResult.homeTown : ''}</p>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 col-sm-6">
              <div className="well well-sm filter-view">
                <span className="filter-icon"><i className="icon ion-social-twitter"></i></span>
                <h4 className="album-heading">Twitter</h4>
                <p className="sub-head">Followers</p>
                <span className="fa-2x text-green">{this.state.queryResult.followersCount ? numeral(this.state.queryResult.followersCount).format('0 a') : ''}</span>
                <hr />
                <p className="sub-head">Following</p>
                <span className="fa-2x text-green">{this.state.queryResult.friendsCount ? numeral(this.state.queryResult.friendsCount).format('0 a') : ''}</span>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 col-sm-6">
              <div className="well well-sm filter-view">
                <span className="filter-icon"><i className="icon ion-ios-speedometer"></i></span>
                <h4 className="album-heading">CURRENT TREND</h4>
                <span className="fa-2x text-blue">{this.state.queryResult.trend ? this.state.queryResult.trend : ''}</span>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 col-sm-6">
              <div className="well well-sm filter-view">
                <span className="filter-icon"><i className="icon ion-cash"></i></span>
                <h4 className="album-heading">TOTAL PROFIT</h4>
                <span className="fa-2x">${Math.floor(totalProfit)}</span>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 col-sm-6">
              <div className="well well-sm filter-view">
                <span className="filter-icon"><i className="icon ion-pie-graph"></i></span>
                <h4 className="album-heading">AVERAGE PROFIT PER TICKET </h4>
                <span className="fa-2x">${Math.floor(avgProfit)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="filter-box">
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">Top Countries</h3>
                </div>
                <div className="panel-body">
                  {this.state.queryResult.topCountries ? this.state.queryResult.topCountries.map(country => {
                    return (

                      <div className="parcentage-view flex-row">
                        <div className="parcentage-value">
                          {numeral(country.percent / 100).format('0%')}
                        </div>
                        <div className="parcentage-title">{country.title}</div>
                      </div>
                    )
                  }) : ''}
                </div>
				<div className="clearfix"></div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">Top Cities</h3>
                </div>
                <div className="panel-body">
                  {this.state.queryResult.topCities ? this.state.queryResult.topCities.map(city => {
                    return (

                      <div className="parcentage-view flex-row">
                        <div className="parcentage-value">
                          {numeral(city.percent / 100).format('0%')}
                        </div>
                        <div className="parcentage-title">{city.title}</div>
                      </div>
                    )
                  }) : ''}
                </div>
				<div className="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <Alert />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Research/Research.js